import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';

import Home from './pages/Home';
import Catalog from './pages/Catalog';
import ProductDetail from './pages/ProductDetail';
import Checkout from './pages/Checkout';
import './App.css';

export default function App() {
  // ——— Global cart state ———
  const [cart, setCart] = useState([]);

  const addToCart = (product) => {
    setCart((prev) => [...prev, product]);
  };

  // Remove a single item
  const removeFromCart = (id) => {
    setCart((prev) => prev.filter((item) => item.id !== id));
  };

  // Clear all items
  const clearCart = () => {
    setCart([]);
  };

  return (
    <BrowserRouter>
      <header className="app-header">
        <nav className="nav-bar">
          <Link className="nav-link" to="/">
            Home
          </Link>
          <Link className="nav-link" to="/catalog">
            Catalog
          </Link>
          <Link className="nav-link" to="/checkout">
            Checkout ({cart.length})
          </Link>
        </nav>
      </header>

      <main className="app-content">
        <Routes>
          <Route path="/" element={<Home onAddToCart={addToCart} />} />
          <Route
            path="/catalog"
            element={<Catalog onAddToCart={addToCart} />}
          />
          <Route
            path="/product/:id"
            element={<ProductDetail onAddToCart={addToCart} />}
          />
          <Route
            path="/checkout"
            element={
              <Checkout
                cart={cart}
                removeFromCart={removeFromCart}
                clearCart={clearCart}
              />
            }
          />
        </Routes>
      </main>
    </BrowserRouter>
  );
}
